import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/pricing')({
  component: lazyRouteComponent(() => import('./-pricing.lazy'), 'default'),
  validateSearch: (search: Record<string, unknown>) => ({
    orgId: typeof search.orgId === 'string' ? search.orgId : undefined,
  }),
});
